import { getCurrentUser, API_BASE_URL } from './base';

export const changeEmail = async (newEmail) => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error("No authenticated user");

    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE_URL}/api/user/change-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ newEmail }),
    });

    if (!response.ok) {
      let resError = await response.json()
      throw new Error(resError.message || resError.error || `Error changing email. Please try later.`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    throw error;
  }
};

export const verifyNewEmail = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/user/verify-new-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      throw new Error(`Error verifying email.`);
    }

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error verifying email:", error);
    throw error;
  }
};
